import sjcl from "sjcl";

export function Encrypt(message: any) {
  try {
    return sjcl.encrypt(process.env.REACT_APP_SECRET_KEY, message);
  } catch (ex) {
    return message;
  }
}

// Decrypt a message
export function Decrypt(ciphertext: any) {
  try {
    return sjcl.decrypt(process.env.REACT_APP_SECRET_KEY, ciphertext);
  } catch (ex) {
    return ciphertext;
  }
}
